import { isEmpty } from 'lodash/fp';

const addDecision = <T extends string>(currentDecisions: ReadonlyArray<T>, depth: number, newDecision: T | null) => {
  const decisions = currentDecisions.slice(0, depth);
  if (isEmpty(newDecision)) {
    return decisions;
  }
  return decisions.concat(newDecision);
};

export default addDecision;
